var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeliveryFailed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #6b21a8;\n      }\n\n      .st1 {\n        stroke: #a78bfa;\n        stroke-width: 35px;\n      }\n\n      .st1, .st2 {\n        fill: none;\n        stroke-linecap: round;\n      }\n\n      .st3 {\n        stroke-linejoin: round;\n      }\n\n      .st3, .st4 {\n        fill: #fff;\n        stroke: #6b21a8;\n        stroke-width: 45px;\n      }\n\n      .st5 {\n        fill: #d8b4fe;\n        isolation: isolate;\n        opacity: .3;\n      }\n\n      .st2 {\n        stroke: #fff;\n        stroke-width: 55px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "package"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 160,
    y: 260,
    width: 650,
    height: 520,
    rx: 60,
    ry: 60
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M390,260v205l95-75,95,75v-205"
  }), /*#__PURE__*/React.createElement("g", {
    id: "label"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 244.48,
    y1: 649,
    x2: 379.92,
    y2: 649
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 260.04,
    y1: 591.53,
    x2: 359.03,
    y2: 591.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 230.7,
    y1: 706,
    x2: 393.7,
    y2: 706
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "error-badge"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 750,
    cy: 649,
    r: 225
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 750,
    cy: 649,
    r: 205
  }), /*#__PURE__*/React.createElement("g", {
    id: "x-mark"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 635,
    y1: 534,
    x2: 865,
    y2: 764
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 865,
    y1: 534,
    x2: 635,
    y2: 764
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryFailed);
export default __webpack_public_path__ + "static/media/deliveryFailed.e54d5cfed310a046cefd8d575fff9fef.svg";
export { ForwardRef as ReactComponent };